import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'orderExecution';

const orderExecutionService = {
  getOrders: (data, signal) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
      signal,
    });
  },

  updateOrderLine: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}`,
      data,
    });
  },

  updateOrderHead: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/head`,
      data,
    });
  },
};

export default orderExecutionService;
